import { Phone, Mail } from "lucide-react";
import { DIRECT_BOOKING } from "@/data/content";

export const DirectBookingCard = () => (
  <div
    className="rounded-2xl border border-[#D4AF37]/50 bg-gradient-to-br from-[#FDFBF7] to-[#F5EFEB] p-6"
    data-testid="direct-booking-card"
  >
    <div className="text-xs uppercase tracking-[0.24em] font-semibold text-[#6E2638]">
      Prefer to book directly?
    </div>
    <p className="mt-3 text-sm text-[#1A1817]/85 leading-relaxed">
      Call or text Martin, or drop him a line — happy to take your booking the old-fashioned way.
    </p>
    <div className="mt-4 space-y-2">
      <a
        href={`tel:${DIRECT_BOOKING.phone_link}`}
        className="flex items-center gap-2 text-[#6E2638] serif text-lg hover:underline"
        data-testid="direct-book-phone"
      >
        <Phone size={16} /> {DIRECT_BOOKING.phone_display}
      </a>
      <a
        href={`mailto:${DIRECT_BOOKING.email}`}
        className="flex items-center gap-2 text-[#6E2638] text-sm hover:underline break-all"
        data-testid="direct-book-email"
      >
        <Mail size={16} /> {DIRECT_BOOKING.email}
      </a>
    </div>
  </div>
);

export default DirectBookingCard;
